exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.mainWrapper[data-v-7ca5082e] {\n  background-color: #ffffff;\n}\n", "", {"version":3,"sources":["/home/runner/work/web/web/b2c-customer-mobile/src/components/register/agentRegistration/agentRegistrationLayout-Interim.vue"],"names":[],"mappings":";AA2FA;EACE,0BAA0B;CAC3B","file":"agentRegistrationLayout-Interim.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.mainWrapper {\n  background-color: #ffffff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ca5082e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/register/agentRegistration/agentRegistrationLayout-Interim.vue
// module id = c9w4
// module chunks = 0